import api from "./api";

export async function getOutlets() {

    const response = await api.get(
        "/api/v1/nextgo/outlets"
    );

    return response.data;

}